/**
 * Email address format — the one rule the whole platform agrees on.
 *
 * A format check, NOT deliverability: a local part, an @, a domain, and a TLD.
 * Rejects `hello`, `hello@diality` (no TLD), `admin@` (no domain), `foo@bar`.
 * Accepts plus-addressing (`sam+news@example.com`) — a tag in the local part is
 * a legitimate address, and some visitors use one deliberately.
 *
 * Consumed by:
 *  - the subscribers Lambda (server-side validation — the authority), and
 *  - the Cta email-capture block (the visitor's inline guidance),
 * so what one of them rejects the others reject too.
 */
export function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
//# sourceMappingURL=email.js.map